var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCarouselNavArrowRight = function SvgCarouselNavArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    style: {
      fill: "none"
    },
    viewBox: "0 0 81 81.121",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 5.486c27 15.589 27 54.56 0 70.148S0 71.737 0 40.56C0 9.384 33.75-10.102 60.75 5.486z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m34.5 25.56 15.43 14.917L34.5 55.393",
    style: {
      strokeLinecap: "square",
      strokeWidth: 5,
      stroke: "#fff"
    }
  }));
};

export { SvgCarouselNavArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iNDYiIHN0eWxlPSJmaWxsOm5vbmUiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDgxIDgxLjEyMDYyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KIDxwYXRoIGQ9Im02MC43NSA1LjQ4NjQxMjljMjcgMTUuNTg4NDAwMSAyNyA1NC41NjAwMDAxIDAgNzAuMTQ4MDAwMXMtNjAuNzUtMy44OTctNjAuNzUtMzUuMDc0YzAtMzEuMTc2OTAwMSAzMy43NS01MC42NjI1IDYwLjc1LTM1LjA3NDAwMDF6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KIDxwYXRoIGQ9Im0zNC41IDI1LjU2MDQxMyAxNS40MzA4IDE0LjkxNjQtMTUuNDMwOCAxNC45MTY1IiBzdHlsZT0ic3Ryb2tlLWxpbmVjYXA6c3F1YXJlO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojZmZmIi8+Cjwvc3ZnPgo=";